// extracted by css-extract-rspack-plugin
export default {"content":"content-Nsmx4k","imageContainer":"imageContainer-QT7yDC","image":"image-QEqnUK","document":"document-YRKnGq"};